export const STORAGE_KEY_PREFIX = 'hiboo__';

export const MAPBOX_TOKEN = window.MAPBOX_TOKEN;

export const INTERCOM_APP_ID = window.INTERCOM_APP_ID;

export const CLOUDFLARE_TURNSTILE_SITE_KEY = '0x4AAAAAACuKEUC8RfjdNt11';

export const MAP_STYLE_LIGHT = 'mapbox://styles/mapbox/light-v11';

export const MAP_STYLE_STREETS = 'mapbox://styles/mapbox/streets-v12';

export const DEFAULT_MAP_STYLE = 'mapbox://styles/mapbox/satellite-streets-v12';

export const MAX_ZOOM = 20;

export const defaultGeoJsonAreaStyle = {
  color: 'blue',
  colorSurface: true,
};

export const GEO_ZONE_FILL_OPACITY = 0.05;
